/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Supply_Air_Max_Temperature_SetpointInputs */



/**
* | output |
* | --- |
* | "Maximum supply setpoint" |
*
* @param {Supply_Air_Max_Temperature_SetpointInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const supply_air_max_temperature_setpoint = /** @type {((inputs?: Supply_Air_Max_Temperature_SetpointInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Supply_Air_Max_Temperature_SetpointInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maximum supply setpoint")
	return /** @type {LocalizedString} */ ("Consigne maximum soufflage")
});